import React from 'react';
import { Icon } from '@fuxi/eevee-icon';
import { MassageType2Text } from '@/constant';
import CheckRight from '@/assets/icon/CheckRight.svg';
import cx from './index.module.scss';

interface Props {
  selectPlanItem: GetAllProductsResponse;
  handleClick: (item: GetAllProductsResponse, idx: number) => void;
  planList: GetAllProductsResponse[];
}

const PlanCards: React.FC<Props> = ({ handleClick, selectPlanItem, planList }) => {
  return (
    <>
      {planList?.map((item: GetAllProductsResponse, idx) => {
        const currentIsActiveItem =
          selectPlanItem?.storeGoodsId === item?.storeGoodsId && selectPlanItem?.isDraft === item?.isDraft;

        return (
          <div className={cx('list-item')} key={'plan-' + idx} onClick={() => handleClick(item, idx)}>
            <div
              className={cx('img-box', item?.bodyPart, {
                active: currentIsActiveItem,
              })}
              style={{ backgroundImage: `url(${item?.wxCoverImage})` }}
            >
              {currentIsActiveItem ? (
                <div className={cx('active-bg')} style={{ backgroundImage: `url(${item?.coverSelectedImage})` }} />
              ) : (
                <div className={cx('color-box')}></div>
              )}
              <div className={cx('header-box')}>
                <div className={cx('header')}>
                  {!!item?.brandLogo ? (
                    <div
                      className={cx('name', 'custom-logo', {
                        'is-draft': item.isDraft,
                        'name-active': currentIsActiveItem,
                      })}
                    >
                      <div className={cx('logo')}>
                        <img src={item?.brandLogo} alt="logo" />
                        <div className={cx('line', { active: currentIsActiveItem })} />
                      </div>

                      <div className={cx('goods-name')}>
                        <span className={cx({ nbsp: !!item?.brandLogo })} />
                        <span className={cx('label')}>{item.name}</span>
                      </div>
                    </div>
                  ) : (
                    <div className={cx('name', { 'is-draft': item.isDraft, 'name-active': currentIsActiveItem })}>
                      {item.name}
                    </div>
                  )}

                  <div className={cx('header-tag', { active: currentIsActiveItem })}>
                    {item?.items?.map((treatType, idx) => (
                      <div className={cx(treatType + '-tags', 'type')} key={'treatType-' + idx}>
                        {MassageType2Text[treatType]}
                      </div>
                    ))}
                  </div>
                </div>

                {/* 人工套餐无部位区分 */}
                {item?.onlyManual ? (
                  <div className={cx('only-manual')}>
                    <Icon name="only-hand" className={cx('icon')} size="12px" />
                    <span>仅支持人工操作</span>
                  </div>
                ) : currentIsActiveItem ? (
                  <div className={cx('tag-container')}>
                    {item?.padTags?.filter(Boolean)?.map((tag, idx) => (
                      <div className={cx('tag')} key={'tag-' + idx}>
                        {tag}
                      </div>
                    ))}
                  </div>
                ) : (
                  !!item?.recommendedTime && (
                    <div
                      className={cx('time', {
                        'time-active': currentIsActiveItem,
                      })}
                    >{`${item?.recommendedTime}分钟`}</div>
                  )
                )}

                {/* 人工套餐无部位区分 */}
              </div>
              {currentIsActiveItem && (
                <div className={cx('bottom-box')}>
                  {item?.recommendedTime && <span className={cx('minute-text')}>{`${item?.recommendedTime}分钟`}</span>}
                  <div className={cx('select-icon')}>
                    已选择
                    <img className={cx('checkbox-right')} alt="checkbox" src={CheckRight}></img>
                  </div>
                </div>
              )}
            </div>
          </div>
        );
      })}
    </>
  );
};

export default React.memo(PlanCards);
